import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['form', 'section', 'fileFormat', 'csvOptions'];

	connect() {
		this.updateFormat();
	}

	updateFormat() {
		if (!this.hasFileFormatTarget || !this.hasCsvOptionsTarget) return;
		const fileFormat = this.fileFormatTargets.find((input) => input.checked)?.value;
		this.csvOptionsTarget.classList.toggle('hidden', fileFormat !== 'csv');
	}

	toggle(evt) {
		evt.preventDefault();

		this.sectionTarget.classList.toggle('hidden');
		this.formTarget.classList.toggle('hidden');
	}
}
